import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MainSchema from './MainSchema';
import getLocale from '../../../lib/utils/getLocale';
import { canonicalizeString } from '../../../lib/utils';

function mapStateToProps({ geoIp }, { match }) {
  const { url } = match;
  const cleanPath = url.endsWith('/') ? url.substring(0, url.lastIndexOf('/')) : url;
  const canonicalPath = canonicalizeString(cleanPath, true);
  return {
    canonicalUrl: `https://www.gasbuddy.com${canonicalPath}`,
    language: getLocale(geoIp.geoIpInfo.country),
    path: match.url,
  };
}
export default withRouter(connect(mapStateToProps)(MainSchema));
